<template>
	<div class="container py-5">

		<h1 class="display-2 mt-4 mb-3 text-center">{{ $t('product_title') }}</h1>
		<h3 class="mb-5 text-center">{{ $t('product_description') }}</h3>
		<!-- <p class="text-center w-50 m-auto">{{ $t('product_introduction') }}</p> -->
		<hr>

		<p v-if="fetchError" class="text-danger">{{ fetchErrorMessage }}</p>

		<div class="d-flex row">

			<!-- Loading icon -->
			<div v-if="modules.length == 0" class="text-center p-5">
				<div class="spinner-border text-warning" style="width: 3rem; height: 3rem;" role="status"></div>
			</div>

			<!-- Module list -->
			<div v-for="(module, index) in modules" :key="module.id" class="col-4 p-2">
				<div class="card">
					<!-- <img :src='"@/assets/backgrounds/m1_t1.jpg"'> -->
					<!-- <img class="card-image" :src='"@/assets/backgrounds/" + backgrounds[module.id] + ".jpg"'> -->
					<div class="card-image" :style="cssBackground[module.id]"></div>
					<div class="card-body">
						<div class="card-blur p-1 position-relative">
							<p class="card-subtitle my-2">{{ $t('module') }} {{ index+1 }}</p>
							<h5 class="card-title">{{ moduleText(module.id, 'title') }}</h5>
							<p class="card-text">{{ moduleText(module.id, 'description') }}</p>
							<router-link
								class="start-button btn btn-warning px-5"
								:class="{ disabled: module.tasks.length == 0 }"
								:to="{ name: 'Module', params: { moduleName: module.name } }">
								{{ $t('quiz_button_start') }}
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
export default {
	props: [],
	components: {},
	data() {
		return {
			// backgrounds: {
				// "m1": "m1_t1",
				// "m2": "m2_t1",
				// "m3": "m3_t1"
			// },
			modules: [],
			cssBackground: {
				"m1": {
					backgroundImage: `url(${require(`@/assets/backgrounds/m1_t1.jpg`)})`,
					backgroundPosition: "100% 90%",
					backgroundSize: "auto 170%"
				},
				"m2": {
					backgroundImage: `url(${require(`@/assets/backgrounds/m2_t1.jpg`)})`,
					backgroundPosition: "100% 10%",
					backgroundSize: "auto 160%"
				},
				"m3": {
					backgroundImage: `url(${require(`@/assets/backgrounds/m3_t1.jpg`)})`,
					backgroundPosition: "70% 100%",
					backgroundSize: "auto 150%"
				},
			}
		};
	},

	methods: {
		moduleText(moduleId, key) {
			return this.$t(`${moduleId}_${key}`);
		},

		onSessionLoad() {
			this.modules = this.$tracker.modules;
		},
	},

	mounted() {
		// this.fetch("/api/get_modules/", data => {
		// 	if (data) {
		// 		this.modules = data;
		// 	}
		// });

		this.onSessionLoad();
	},
};
</script>



<style scoped>
	.card {
		/*background: red;*/
		/*border-radius: 40px;*/
		border: none;
		/*border: 1px solid #CCC;*/
		overflow: hidden;
		/*background-origin: border-box;*/
		/*background-position: right;*/
		/*background-size: 200%;*/
		text-align: center;

		background: white;
		border: 1px solid #00000022;
	}

	.card-image {
		border-bottom: 1px solid #00000022;
		height: 10em;
		background-size: cover;
	}

	.card-body {
		/*background: rgba(0,0,0,0.4);*/
		/*backdrop-filter: blur(5px);*/
	}

	.card-blur {
		/*background: yellow;*/
	}

	.card-title, .card-text, .card-subtitle {
		/*text-shadow: 0 0 10px white, 0 0 10px white, 0 0 10px white, 0 0 10px white;*/
		/*color: white;*/
	}

	.start-button {
		position: absolute;
		top: -2.25em;
		right: 0em;
		border-radius: 100em;
		border: 1px solid #00000022;
	}
</style>
